import { chip, money } from '../../components/ui/estilos';
import { Kpis, Progreso, Tabla, Tarjeta } from './ui';
import { num } from './useReporte';

// Antes era la página "Mejores días" (/ventas-por-dia); ahora es una pestaña de
// Clientes y operación y usa el periodo de arriba. Datos: GET /caja/ventas-por-dia.
const DIAS_SEMANA = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

// '2026-07-26' se parsea a mano: new Date('2026-07-26') es UTC y en México mostraría el día anterior.
function fecha(f: string, larga = false) {
  const [a, m, d] = String(f).slice(0, 10).split('-').map(Number);
  const dow = DIAS_SEMANA[new Date(a, m - 1, d).getDay()];
  return larga ? `${dow} ${d}/${m}/${a}` : `${dow.slice(0, 3)} ${d}/${m}`;
}

export default function MejoresDias({ datos }: { datos: any }) {
  const r = datos?.resumen;
  const dias: any[] = datos?.dias || [];
  const semana: any[] = datos?.semana || [];
  if (!r) return <div style={{ color: 'var(--muted)' }}>Sin ventas en este periodo.</div>;
  const maxSemana = Math.max(1, ...semana.map(s => num(s.promedio_por_dia)));
  const mejorDow = semana[0]?.dow;

  return <>
    <Kpis items={[
      { label: 'Venta total', valor: money(num(r.total)) },
      { label: 'Tickets', valor: Number(r.tickets || 0).toLocaleString('es-MX') },
      { label: 'Ticket promedio', valor: money(num(r.ticket_promedio)) },
      { label: 'Promedio por día', valor: money(num(r.promedio_diario)), delta: { texto: `${r.dias_operados} día(s) con ventas`, color: 'var(--muted)' } },
    ]} />

    {r.mejor_dia && (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(260px, 100%), 1fr))', gap: 14 }}>
        <Tarjeta titulo="Mejor día del periodo" extra={<span style={{ ...chip('var(--ok-bg)', 'var(--ok)'), fontSize: 13 }}>Mejor</span>}>
          <div style={{ fontSize: 20, fontWeight: 700 }}>{fecha(r.mejor_dia.dia, true)}</div>
          <div style={{ color: 'var(--muted)' }}>{money(num(r.mejor_dia.total))} · {r.mejor_dia.tickets} tickets</div>
        </Tarjeta>
        {r.peor_dia && r.peor_dia.dia !== r.mejor_dia.dia && (
          <Tarjeta titulo="Día más flojo (con ventas)" extra={<span style={{ ...chip('var(--danger-bg)', 'var(--danger)'), fontSize: 13 }}>Flojo</span>}>
            <div style={{ fontSize: 20, fontWeight: 700 }}>{fecha(r.peor_dia.dia, true)}</div>
            <div style={{ color: 'var(--muted)' }}>{money(num(r.peor_dia.total))} · {r.peor_dia.tickets} tickets</div>
          </Tarjeta>
        )}
      </div>
    )}

    <Tarjeta titulo="¿Qué días de la semana venden más?" extra={<span style={{ fontSize: 13, color: 'var(--muted)' }}>promedio por día abierto</span>}>
      {!semana.length && <div style={{ color: 'var(--muted)' }}>Sin ventas en este periodo.</div>}
      {semana.map(s => (
        <Progreso key={s.dow} label={`${s.dow === mejorDow ? '⭐ ' : ''}${DIAS_SEMANA[s.dow]} · ${s.dias_operados} día(s) · ${s.tickets} tickets`}
          valor={`${money(num(s.promedio_por_dia))} /día`} pct={num(s.promedio_por_dia) / maxSemana * 100} />
      ))}
    </Tarjeta>

    <Tarjeta titulo="Detalle día por día">
      <Tabla vacio="Sin ventas en este periodo."
        columnas={[{ t: 'DÍA', w: '110px' }, { t: 'TOTAL', w: '110px', der: true }, { t: 'TICKETS', w: '80px', der: true }, { t: 'TICKET PROM.', w: '110px', der: true }, { t: 'PROPINAS', w: '100px', der: true }]}
        filas={dias.map(d => {
          const mejor = r.mejor_dia && d.dia === r.mejor_dia.dia;
          const vacio = !d.tickets;
          return [
            <span style={{ fontWeight: mejor ? 700 : 400, color: vacio ? 'var(--muted)' : undefined }}>{mejor ? '🏆 ' : ''}{fecha(d.dia)}</span>,
            <b style={{ color: vacio ? 'var(--muted)' : undefined }}>{money(num(d.total))}</b>,
            d.tickets, d.tickets ? money(num(d.ticket_promedio)) : '—', num(d.propina) ? money(num(d.propina)) : '—',
          ];
        })} />
    </Tarjeta>
  </>;
}
